import ControlFilter from "components/shared/ControlFilter";
import type { TPaidStatus } from "hooks/useAPIPagination";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export type TPaymentStatusOption = { value: TPaidStatus; label: string };

interface IPaymentFilter {
    paidStatus: TPaidStatus;
    setPaidStatus: React.Dispatch<React.SetStateAction<TPaidStatus>>;
    /**
     * After choosing a payment filter, reset table pagination
     */
    resetPagination: () => void;
    selector?: boolean;
    /**
     * Extra action to perform on status change.
     */
    onChange?: (status: TPaidStatus) => void;
    allowCancelledStatus?: boolean;
    highlight?: boolean;
}

const PaymentFilter = ({
    paidStatus,
    setPaidStatus,
    resetPagination,
    selector = false,
    onChange,
    allowCancelledStatus = false,
    highlight = false,
}: IPaymentFilter) => {
    const [t] = useTranslation();

    const paymentStatusOptions: TPaymentStatusOption[] = [
        { value: "all", label: t("Filters.AllMasculine") },
        { value: "paid", label: t("Filters.Paid") },
        { value: "topay", label: t("Filters.ForTransfer") },
        {
            value: "unpaid",
            label: allowCancelledStatus ? t("PartialPayment.PaymentPage.Cancelled") : t("Filters.Unpaid"),
        },
    ];

    const handlePaymentChange = (paymentStatus: TPaidStatus) => {
        resetPagination();
        setPaidStatus(paymentStatus);
        onChange && onChange(paymentStatus);
    };

    const controlLabel = useMemo(() => {
        const status = paymentStatusOptions.find((item) => item.value === paidStatus);
        return status ? status.label : "all";
    }, [paidStatus]);

    return (
        <ControlFilter
            filterOptions={paymentStatusOptions}
            controlValue={paidStatus}
            controlLabel={controlLabel}
            onValueChange={handlePaymentChange}
            filterLabel={t("Filters.PaymentStatus")}
            selector={selector}
            highlight={highlight}
        />
    );
};
export default PaymentFilter;
